<template>
  <div style="width:350px;margin:0 auto;text-align:center" class="mt-5">
    <div v-if="url === ''">
      <v-text-field
        type="text"
        style="width:350px;margin:0 auto;height:60px"
        label="Amount"
        v-model="amount"
        solo
      />
      <v-btn color="primary" style="width:350px;margin:0 auto;" @click="submit"
        >Pay Now</v-btn
      >
    </div>
    <div v-else>
      <vue-qrcode :value="url" :width="200" />
      <p>
        Pay using ICICI UPI and qr code, your balance will get loaded actual in
        short time.
      </p>
      <h3>
        <v-progress-linear indeterminate color="green" />
        Fetching confirmation from bank, <br />Please wait...
      </h3>
      <v-btn flat class="primary" @click="checkStatus">
        Check your payment status via bank
      </v-btn>
    </div>
  </div>
</template>
<script>
import VueQrcode from "vue-qrcode";
import axios from "axios";

export default {
  components: {
    VueQrcode,
  },
  data() {
    return {
      url: "",
      amount: "",
      data: {},
      interval: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    upi_url() {
      return this.$store.state._icici_upi;
    },
  },
  beforeDestroy() {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
  },
  methods: {
    checkStatus() {
      let vm = this;
      if (vm.user == null || !vm.user.phone)
        return vm.$root.notify("error", "Login Required!");
      if (vm.url === "") return;
      let { b2c_transid, transid } = vm.data;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        TransId: transid,
        Source: "json",
        B2C_TransId: b2c_transid,
        Amount: vm.amount,
      };
      let url = vm.upi_url + `Verify_Balance_LoadId`;
      vm.$root.loader = true;
      axios
        .get(url, {
          params: doc,
        })
        .then(({ data }) => {
          vm.$root.loader = false;
          if (data.status === "True") {
            clearInterval(vm.interval);
            vm.url = "";
            vm.data = {};
            vm.amount = "";
          } else {
            vm.$root.alert(data.message);
          }
        })
        .catch(function(error) {
          vm.$root.loader = false;
          vm.$root.notify("error", error.message);
        });
    },
    submit() {
      let vm = this;
      if (vm.user == null || !vm.user.phone)
        return vm.$root.notify("error", "Login Required!");
      if (vm.amount == "") return vm.$root.notify("error", "Amount Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Amount: vm.amount,
      };
      vm.$root.loader = true;
      vm.$store
        .dispatch("axiospost", {
          url: "Generate_ICICI_QrCode",
          data: doc,
        })
        .then(({ data }) => {
          vm.$root.loader = false;
          if (data.status === "True") {
            vm.url = data.data.qrCode_Url;
            vm.data = data.data;
            vm.run();
          } else {
            vm.$root.notify("error", data.message);
          }
        })
        .catch(function(error) {
          vm.$root.notify("error", error.message);
          vm.$root.loader = false;
        });
    },
    async check() {
      let vm = this;
      if (vm.user == null || !vm.user.phone)
        return vm.$root.notify("error", "Login Required!");
      if (vm.url === "") return;
      let { b2c_transid, transid } = vm.data;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        B2C_TransId: b2c_transid,
        Amount: vm.amount,
      };
      let url = vm.upi_url + `Check_QrCode_Status`;
      axios
        .get(url, {
          params: doc,
        })
        .then(({ data }) => {
          console.log(data);
          if (data.status === "True") {
            clearInterval(vm.interval);
            vm.url = "";
            vm.data = {};
            vm.amount = "";
          } else {
            vm.run();
          }
        })
        .catch(function(error) {
          vm.$root.notify("error", error.message);
        });
    },
    run() {
      const vm = this;
      let { interval } = vm;
      if (interval !== null) {
        clearInterval(interval);
      }
      vm.interval = setTimeout(() => {
        vm.check();
      }, 5000);
    },
  },
};
</script>

<style scoped>
.paytmimg {
  width: 170px;
  margin-left: 85px;
}
</style>
